import { getColumnsByNames } from './all-top10-columns-config';

export const topCountryBlockedHits = getColumnsByNames([
    { name: 'country' },
    { name: 'count', width: '40%' }
]);